export enum FormikMessages {
  EMAIL_INVALID = 'Please use a valid email address',
  EMAIL_REQUIRED = 'Please enter your email address',
  PASSWORD_REQUIRED = 'Please enter your password',
  PASSWORD_MATCH = 'Your password and confirmation password must match.',
  CONFIRM_PASSWORD_REQUIRED = "Confirm password can't be empty",
  NICKNAME = "Nickname can't be empty",
  PASSWORD_MIN = 'Password must be at least 8 characters',
  PASSWORD_MAX = 'Password must not be longer than 16 characters',
}
